// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6.75 2.5H17.25V5.25C17.25 6.82062 16.5603 8.23016 15.4672 9.19226C17.3447 9.97683 18.8992 11.379 19.8768 13.1431L20.092 13.5315C19.8975 13.5107 19.7 13.5 19.5 13.5C16.4624 13.5 14 15.9624 14 19C14 20.1068 14.3269 21.1372 14.8895 22H7C4.79086 22 3 20.2091 3 18V17.5C3 13.7583 5.28335 10.5499 8.53267 9.19218C7.43966 8.23008 6.75 6.82058 6.75 5.25V2.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 18V16H16V18H23Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 22V20H16V22H23Z"}}]};

const WealthFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'wealth-filled',
    ref,
    icon: element,
  },
));

WealthFilledIcon.displayName = 'WealthFilledIcon';

export default WealthFilledIcon;
